import lodashOmit from 'lodash/omit';
import { api } from '@/api/api';
import { ContactServerInstance } from './contact_server';
import ContactSelectNotify from './contact_select_notify';
import { ContactDBInstance } from './contact_dbl';
import { ContactTransformInstance } from './contact_transform';
import { util } from '@/api/util';
import { customerFilterNames } from '@/api/logical/contact_constants';
import { apis } from '@/config';
import ContactUtilInterface from './contact_util';
export class ContactEdmHelper {
    constructor() {
        this.systemApi = api.getSystemApi();
        this.storeApi = api.getDataStoreApi();
        this.eventApi = api.getEventApi();
        this.loggerApi = api.requireLogicalApi(apis.loggerApiImpl);
        this.accountApi = api.requireLogicalApi(apis.accountApiImpl);
        this.edmRoleApi = api.requireLogicalApi(apis.edmRoleApiImpl);
        this.contactServer = ContactServerInstance;
        this.contactUtil = ContactUtilInterface;
        this.contactSelectNotify = ContactSelectNotify;
        this.contactDB = ContactDBInstance;
        this.contactTrans = ContactTransformInstance;
        this.dbApi = api.getNewDBApi();
        this.dbName = 'contact_global';
        this.customerSyncTimes = 0;
        this.isSyncing = false;
        this.switchSync = true;
        this.edmLastUpdateTime = Date.now();
        this.tableNames = {
            contact: 'contact',
            org: 'org',
            orgContact: 'orgContact',
            orgManager: 'orgManager',
            label: 'label',
            colleagueContact: 'colleagueContact',
        };
        this.filterFunctions = {
            searchContact: (item, params) => {
                var _a;
                if (!params || !((_a = params.additionalData) === null || _a === void 0 ? void 0 : _a.query)) {
                    return false;
                }
                const reg = new RegExp(util.escapeRegex(params.additionalData.query), 'i');
                const searchItems = ['name', 'contactPYName', 'contactPYLabelName', 'account'];
                return searchItems.some(value => reg.test(item[value]));
            },
            searchOrg: (item, params) => {
                var _a;
                if (!params || !((_a = params.additionalData) === null || _a === void 0 ? void 0 : _a.query)) {
                    return false;
                }
                const reg = new RegExp(util.escapeRegex(params.additionalData.query), 'i');
                const searchItems = ['orgName', 'orgPYName'];
                return searchItems.some(value => reg.test(item[value]));
            },
            searchMyCustomer: (item, params) => {
                var _a, _b;
                if (!params || !((_a = params.additionalData) === null || _a === void 0 ? void 0 : _a.searchParams)) {
                    return false;
                }
                const { query, currentAccountId, type } = params.additionalData.searchParams || {};
                const reg = new RegExp(util.escapeRegex(query), 'i');
                const searchItems = ['orgName', 'orgPYName'];
                return item.type === type && ((_b = item.managerList) === null || _b === void 0 ? void 0 : _b.includes(currentAccountId)) && searchItems.some(value => reg.test(item[value]));
            },
            searchMemoryContact: (item, params) => {
                var _a;
                if (!params || !((_a = params.additionalData) === null || _a === void 0 ? void 0 : _a.query)) {
                    return false;
                }
                const reg = new RegExp(util.escapeRegex(params.additionalData.query), 'i');
                const searchItems = ['contactName', 'contactPYName', 'contactPYLabelName', 'accountName'];
                return searchItems.some(value => reg.test(item[value]));
            },
        };
    }
    getContactEdmLastUpdateTime() {
        return this.edmLastUpdateTime;
    }
    setContactEdmLastUpdateTime(lastUpdateTime) {
        this.edmLastUpdateTime = lastUpdateTime || Date.now();
    }
    getContactEdmSyncTimes() {
        return this.customerSyncTimes;
    }
    async syncCustomerListByManagerId(params) {
        const { idList, page = 1, from = 'filter' } = params;
        try {
            const { success, data } = await this.contactServer.getCustomerListByManagerId({ idList, page, from });
            if (success && data) {
                const promiseList = [];
                if (data.list.length > 0) {
                    const ids = [];
                    data.list.forEach(item => {
                        if (item.company_id) {
                            ids.push(item.company_id);
                        }
                    });
                    promiseList.push(this.contactServer
                        .doGetCustomersFromServerBatch({
                        idList: ids,
                    })
                        .then(async (result) => {
                        if (Array.isArray(result) && result.length > 0) {
                            await this.handleCustomerList({
                                data: result,
                                needDeleteLastData: true,
                                sendEvent: true,
                            });
                            return true;
                        }
                        return false;
                    }));
                }
                if (data.loadMore) {
                    promiseList.push(this.syncCustomerListByManagerId({ idList, page: page + 1, from: data.from }));
                }
                await Promise.all(promiseList);
                return {
                    success: true,
                };
            }
            return {
                success,
            };
        }
        catch (error) {
            return {
                success: false,
            };
        }
    }
    setLastEdmRoleData(params) {
        const { privilegeMap, contactPrivilegeRangeData } = params;
        if (privilegeMap && this.lastEdmRoleViewData === undefined) {
            this.lastEdmRoleViewData = this.edmRoleApi.doGetContactViewPrivilege();
        }
        if (contactPrivilegeRangeData && this.lastEdmRoleViewData === undefined) {
            this.lastEdmRoleRangeData = this.edmRoleApi.doGetContactPrivilegeRangeData();
        }
    }
    async needForceSyncCustomerList() {
        try {
            await Promise.all([this.edmRoleApi.getCurrentPrivilege(), this.edmRoleApi.getModuleDataRange('CONTACT')]);
            const privilegeMap = this.edmRoleApi.doGetPrivilegeMap();
            const roleRangeData = this.edmRoleApi.doGetContactPrivilegeRangeData();
            if (privilegeMap === undefined || roleRangeData === undefined) {
                return { force: false };
            }
            const roleViewData = this.edmRoleApi.doGetContactViewPrivilege();
            if (this.lastEdmRoleRangeData === undefined || this.lastEdmRoleViewData === undefined) {
                this.lastEdmRoleViewData = roleViewData;
                this.lastEdmRoleRangeData = roleRangeData;
                return { force: false };
            }
            if (this.lastEdmRoleViewData !== roleViewData) {
                this.lastEdmRoleViewData = roleViewData;
                this.lastEdmRoleRangeData = roleRangeData;
                return { force: true, idList: roleRangeData };
            }
            const { deleteDiff, insertDiff } = util.getDiffNew(this.lastEdmRoleRangeData, roleRangeData);
            const idList = [...deleteDiff, ...insertDiff];
            if (idList === null || idList === void 0 ? void 0 : idList.length) {
                this.lastEdmRoleViewData = roleViewData;
                this.lastEdmRoleRangeData = roleRangeData;
                return {
                    force: true,
                    idList,
                };
            }
            return {
                force: false,
            };
        }
        catch (e) {
            console.error('[contact_edm] needForceSyncCustomerList error', e);
            return { force: false };
        }
    }
    sendContactEdmNotify(res = {}, syncAll = false) {
        this.setContactEdmLastUpdateTime();
        const customerSyncTimes = this.getContactEdmSyncTimes() + 1;
        this.customerSyncTimes = customerSyncTimes;
        console.log('[contact] contactEdmNotify send', res);
        const contactIdList = res.contactList || [];
        const contactNotifyData = {
            eventName: 'contactEdmNotify',
            eventStrData: syncAll ? 'notifyAll' : 'notify',
            eventSeq: 0,
            noLog: true,
        };
        if (contactIdList.length > 1000) {
            const list = util.sliceList(contactIdList);
            list.forEach((item, i) => {
                window.setTimeout(() => {
                    const eventData = {
                        contactList: item,
                        customerSyncTimes,
                        needSync: i === list.length - 1,
                        type: res.type || 'customer',
                        isForce: res.isForce,
                    };
                    this.eventApi.sendSysEvent(Object.assign(Object.assign({}, contactNotifyData), { eventData }));
                }, 0);
            });
        }
        else {
            const eventData = {
                contactList: contactIdList,
                customerSyncTimes,
                needSync: true,
                type: res.type || 'customer',
                isForce: res.isForce,
            };
            this.eventApi.sendSysEvent(Object.assign(Object.assign({}, contactNotifyData), { eventData }));
        }
    }
    getCurrentDomain() {
        var _a;
        return (_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.domain;
    }
    addFilterRegistry() {
        Object.keys(customerFilterNames).forEach(filterName => {
            this.dbApi.addFilterRegistry({
                filterFunc: this.filterFunctions[filterName],
                name: filterName,
            });
        });
    }
    async handlePushCustomerMgs(params) {
        const idList = params.companyIds;
        if (idList === null || idList === void 0 ? void 0 : idList.length) {
            const result = await this.contactServer.doGetCustomersFromServerBatch({
                idList,
            });
            let newIdList = [];
            let needNotifyContactIdList = new Set();
            const _lastUpdateTime = Date.now();
            if (Array.isArray(result) && result.length > 0) {
                const { orgList, updateContactIdList } = await this.handleCustomerList({
                    data: result,
                    needDeleteLastData: true,
                    sendEvent: true,
                    _lastUpdateTime,
                });
                newIdList = util.getKeyListByList(orgList, 'id', true);
                needNotifyContactIdList = new Set([...updateContactIdList]);
            }
            const { deleteDiff } = util.getDiff(idList.map(this.contactTrans.createCustomerId), newIdList);
            if (deleteDiff.length) {
                const { contactIdList } = await this.deleteDataByOrgId(deleteDiff, _lastUpdateTime);
                needNotifyContactIdList = new Set([...needNotifyContactIdList, ...contactIdList]);
            }
            this.sendContactEdmNotify({
                type: 'customer',
                orgList: deleteDiff,
                contactList: [...needNotifyContactIdList],
            }, true);
        }
    }
    handleCustomerListRes(data) {
        const result = {
            orgList: [],
            managerList: [],
            contactList: [],
            orgContactList: [],
            customerIdList: [],
        };
        const _lastUpdateTime = Date.now();
        data.forEach(item => {
            var _a;
            const orgId = this.contactTrans.createCustomerOrgId(item, 'customer');
            result.customerIdList.push(orgId);
            const hasEmail = !!((_a = item.contact_list) === null || _a === void 0 ? void 0 : _a.some((curContact) => curContact.email));
            if (!item.delFlag && hasEmail) {
                const res = this.contactTrans.transToContact(item, 'customer', _lastUpdateTime);
                result.contactList = result.contactList.concat(res.contactList);
                result.orgContactList = result.orgContactList.concat(res.orgContactList);
                result.managerList = result.managerList.concat(this.contactTrans.transCustomerToOrgManager(item, _lastUpdateTime));
                result.orgList.push(this.contactTrans.transCustomerToOrg(item, _lastUpdateTime));
            }
        });
        return result;
    }
    handleCustomerListSeverRes(data) {
        const result = [];
        const _lastUpdateTime = Date.now();
        data.forEach(item => {
            var _a;
            const hasEmail = !!((_a = item.contact_list) === null || _a === void 0 ? void 0 : _a.some((curContact) => curContact.email));
            if (!item.delFlag && hasEmail) {
                let transDataItem = {};
                const org = this.contactTrans.transCustomerToOrg(item, _lastUpdateTime);
                const res = this.contactTrans.transToContact(item, 'customer', _lastUpdateTime);
                const managerList = this.contactTrans.transCustomerToOrgManager(item, _lastUpdateTime);
                transDataItem = Object.assign(Object.assign({}, org), { contactList: res.contactList, orgContactList: res.orgContactList, managerList });
                result.push(transDataItem);
            }
        });
        return result;
    }
    async handleCustomerList(params) {
        const { data, needDeleteLastData = true, _lastUpdateTime } = params;
        const { orgList, managerList, contactList, orgContactList, idList, contactModelList } = this.contactTrans.transServerRepToDB(data, 'customer', _lastUpdateTime);
        let saveRes = {
            updateContactIdList: [],
            updateOrgContactIdList: [],
            updateOrgManagerIdList: [],
        };
        try {
            saveRes = await this.doSaveCustomerListToDB({
                orgList,
                contactList,
                managerList,
                orgContactList,
                idList,
                needDeleteLastData,
            });
            const contactIdList = util.getKeyListByList(contactList, 'id');
            const orgIdList = util.getKeyListByList(orgList, 'id');
            this.sendContactEdmNotify({
                contactList: contactIdList,
                orgList: orgIdList,
                type: 'customer',
            }, params.sendEvent);
        }
        catch (e) {
            console.error('[contact_edm] handleCustomerList error', e);
        }
        return Object.assign({ orgList,
            managerList,
            contactList,
            orgContactList,
            contactModelList }, saveRes);
    }
    async handleClueList(params) {
        const { data, needDeleteLastData = true, _lastUpdateTime } = params;
        const { orgList, managerList, contactList, orgContactList, idList, contactModelList } = this.contactTrans.transServerRepToDB(data, 'clue', _lastUpdateTime);
        let saveRes = {
            updateContactIdList: [],
            updateOrgContactIdList: [],
            updateOrgManagerIdList: [],
        };
        try {
            saveRes = await this.doSaveCustomerListToDB({
                orgList,
                contactList,
                managerList,
                orgContactList,
                idList,
                needDeleteLastData,
            });
            const contactIdList = util.getKeyListByList(contactList, 'id');
            const orgIdList = util.getKeyListByList(orgList, 'id');
            this.sendContactEdmNotify({
                contactList: contactIdList,
                orgList: orgIdList,
                type: 'clue',
            });
        }
        catch (e) {
            console.error('[contact_edm] handleClueList error', e);
        }
        return Object.assign({ orgList,
            managerList,
            contactList,
            orgContactList,
            contactModelList }, saveRes);
    }
    async doSaveCustomerListToDB(params) {
        const { orgList, contactList, orgContactList, managerList, needDeleteLastData = true, idList } = params;
        let updateContactIdList = new Set();
        let updateOrgContactIdList = new Set();
        let updateOrgManagerIdList = new Set();
        if (!Array.isArray(orgList) || orgList.length === 0) {
            return {
                updateContactIdList: [],
                updateOrgContactIdList: [],
                updateOrgManagerIdList: [],
            };
        }
        await Promise.all([
            this.putAll(this.tableNames.org, orgList),
            this.putAll(this.tableNames.contact, contactList),
            this.putAll(this.tableNames.orgContact, orgContactList),
            this.putAll(this.tableNames.orgManager, managerList),
        ]);
        contactList === null || contactList === void 0 ? void 0 : contactList.forEach(item => {
            updateContactIdList.add(item.id);
        });
        orgContactList === null || orgContactList === void 0 ? void 0 : orgContactList.forEach(item => {
            updateOrgContactIdList.add(item.id);
        });
        managerList === null || managerList === void 0 ? void 0 : managerList.forEach(item => {
            updateOrgManagerIdList.add(item.id);
        });
        const { _lastUpdateTime } = orgList[0];
        if (needDeleteLastData && idList.length && _lastUpdateTime) {
            const { contactIdList = [], orgContactIdList = [], orgManagerIdList = [] } = await this.deleteDataByOrgId(idList, _lastUpdateTime);
            updateContactIdList = new Set([...updateContactIdList, ...contactIdList]);
            updateOrgContactIdList = new Set([...updateOrgContactIdList, ...orgContactIdList]);
            updateOrgManagerIdList = new Set([...updateOrgManagerIdList, ...orgManagerIdList]);
        }
        return {
            updateContactIdList: [...updateContactIdList],
            updateOrgContactIdList: [...updateOrgContactIdList],
            updateOrgManagerIdList: [...updateOrgContactIdList],
        };
    }
    createRole(role, type) {
        return (role + type);
    }
    parseRole(role) {
        console.log(role);
        return {
            customerType: 'customer',
            customerRole: 'manager',
        };
    }
    async doSearchAll(params) {
        const start = Date.now();
        const { query } = params;
        const [_contactList, _searchOrgList] = await Promise.all([this.doSearchContact({ query }), this.doSearchOrg({ query })]);
        const idList = util.getKeyListByList(_contactList, 'id');
        const orgContactList = await this.getOrgContactById({ idList, field: 'contactId', needLog: true });
        const contactOrgMap = new Map();
        const orgIdSet = new Set();
        _searchOrgList.forEach(item => {
            orgIdSet.add(item.id);
        });
        orgContactList.forEach(item => {
            contactOrgMap.set(item.contactId, item.orgId);
            orgIdSet.add(item.orgId);
        });
        const orgIdList = [...orgIdSet];
        const [orgManagerList, orgList] = await Promise.all([
            this.getOrgManagerByOrgId({
                idList: orgIdList,
                needLog: true,
            }),
            this.getDataById({
                tableName: 'org',
                idList: orgIdList,
                needLog: true,
            }),
        ]);
        const orgIdRole = await this.getOrgAllRole(orgManagerList);
        const contactList = _contactList.filter(item => {
            const orgId = contactOrgMap.get(item.id);
            const { hasRole } = this.getCustomerRole(orgIdRole, orgId);
            return hasRole;
        });
        contactList.sort((a, b) => {
            const aOrgId = contactOrgMap.get(a.id);
            const bOrgId = contactOrgMap.get(b.id);
            const { customerRole: aRole } = this.getCustomerRole(orgIdRole, aOrgId);
            const { customerRole: bRole } = this.getCustomerRole(orgIdRole, bOrgId);
            const curNumber = this.getCustomerOrderNumber(a.customerType, aRole);
            const preNumber = this.getCustomerOrderNumber(b.customerType, bRole);
            return curNumber > preNumber ? -1 : 1;
        });
        const searchOrgList = _searchOrgList.filter(item => {
            const { hasRole } = this.getCustomerRole(orgIdRole, item.id);
            return hasRole;
        });
        searchOrgList.sort((a, b) => {
            const { customerRole: aRole } = this.getCustomerRole(orgIdRole, a.id);
            const { customerRole: bRole } = this.getCustomerRole(orgIdRole, b.id);
            const curNumber = this.getCustomerOrderNumber(a.customerType, aRole);
            const preNumber = this.getCustomerOrderNumber(b.customerType, bRole);
            if (curNumber === preNumber) {
                return a.orgRank > b.orgRank ? -1 : 1;
            }
            return curNumber > preNumber ? -1 : 1;
        });
        const orgMap = new Map();
        orgList.forEach(item => {
            orgMap.set(item.id, item);
        });
        const contact = contactList.map(item => {
            const curOrgId = contactOrgMap.get(item.id);
            const tranModel = this.contactTrans.transCustomerToContactModel(item);
            const mode = util.addHitQuery({
                data: tranModel,
                queryList: [query],
                hitList: this.contactUtil.contactTableHitList,
            });
            if (curOrgId) {
                const curOrg = orgMap.get(curOrgId);
                if (curOrg) {
                    const { customerRole } = this.getCustomerRole(orgIdRole, curOrgId);
                    mode.customerOrgModel = {
                        role: customerRole,
                        companyId: curOrgId,
                    };
                }
            }
            return mode;
        });
        const customer = [];
        const clue = [];
        searchOrgList.forEach(_item => {
            const item = util.addHitQuery({
                data: _item,
                queryList: [query],
                hitList: this.contactUtil.orgTableHitList,
            });
            const { customerRole } = this.getCustomerRole(orgIdRole, item.id);
            if (item.customerType.startsWith('customer')) {
                customer.push(Object.assign(Object.assign({}, item), { customerRole }));
            }
            else {
                clue.push(Object.assign(Object.assign({}, item), { customerRole }));
            }
        });
        this.logger('contact_edm_doSearchAll', this.useTime(start));
        return {
            contact,
            customer,
            clue,
        };
    }
    async getContactId() {
        const contactId = this.contactUtil.getCurrentContactId();
        if (!contactId) {
            try {
                await this.accountApi.doGetMailAliasAccountListV2();
            }
            catch (e) {
                throw new Error('request contactId fail');
            }
        }
        return this.contactUtil.getCurrentContactId();
    }
    async getCurrentContactId(params) {
        let account = params === null || params === void 0 ? void 0 : params._account;
        const accountType = (params === null || params === void 0 ? void 0 : params.accountType) || 'email';
        if (accountType === 'email') {
            account = account || this.contactUtil.getCurrentAccount();
            if (account === this.contactUtil.getCurrentAccount()) {
                return this.getContactId();
            }
            const contactItemList = await this.contactDB.getContactItemListByItem([account]);
            const curContactItem = contactItemList.find(item => item.contactItemType === 'EMAIL' && item.type === 'enterprise');
            account = curContactItem === null || curContactItem === void 0 ? void 0 : curContactItem.contactId;
        }
        else {
            account = account || (await this.getContactId());
        }
        return account || '';
    }
    async doSearchAllInMemory(params) {
        const start = Date.now();
        const { query, _account: curAccount, edmUseMainAccount = true } = params;
        let _account = curAccount || this.contactUtil.getCurrentAccount();
        if (edmUseMainAccount) {
            _account = this.contactUtil.getCurrentAccount();
        }
        const [contactList, searchOrgList] = await Promise.all([
            this.doSearchContact({
                query,
                dbName: this.contactUtil.edmcontactSearchDbName,
                tableName: this.tableNames.contact,
                filterName: customerFilterNames.searchMemoryContact,
            }),
            this.doSearchOrg({
                query,
                dbName: this.contactUtil.edmcontactSearchDbName,
                tableName: this.tableNames.org,
            }),
        ]);
        const currentAccountId = await this.getCurrentContactId({ _account });
        const viewRole = this.edmRoleApi.doGetContactViewPrivilege();
        const roleAccountIds = this.edmRoleApi.doGetContactPrivilegeRangeData();
        const contact = [];
        contactList.forEach(_item => {
            const item = util.addHitQuery({
                data: _item,
                queryList: [query],
                hitList: this.contactUtil.CustomerContactSearchHitList,
            });
            const customerRole = this.contactUtil.getCustomerRoleByMangerIds({ currentAccountId, managerIds: _item.managerList, roleAccountIds, viewRole });
            if (!customerRole.startsWith('noRole')) {
                contact.push(Object.assign(Object.assign({}, item), { customerRole }));
            }
        });
        contact.sort((a, b) => {
            const aRole = a.customerRole;
            const bRole = b.customerRole;
            const curNumber = this.getCustomerOrderNumber(a.type, aRole);
            const preNumber = this.getCustomerOrderNumber(b.type, bRole);
            return curNumber > preNumber ? -1 : 1;
        });
        const customer = [];
        const clue = [];
        searchOrgList.forEach(_item => {
            const item = util.addHitQuery({
                data: _item,
                queryList: [query],
                hitList: this.contactUtil.orgTableHitList,
            });
            const customerRole = this.contactUtil.getCustomerRoleByMangerIds({ currentAccountId, managerIds: _item.managerList, roleAccountIds, viewRole });
            if (!customerRole.startsWith('noRole')) {
                if (item.type === 2002) {
                    customer.push(Object.assign(Object.assign({}, item), { customerType: 'customer', customerRole }));
                }
                else {
                    clue.push(Object.assign(Object.assign({}, item), { customerType: 'clue', customerRole }));
                }
            }
        });
        customer.sort((a, b) => {
            const curNumber = this.getCustomerOrderNumber('customer', a.customerRole);
            const preNumber = this.getCustomerOrderNumber('customer', b.customerRole);
            if (curNumber === preNumber) {
                return a.orgRank > b.orgRank ? -1 : 1;
            }
            return curNumber > preNumber ? -1 : 1;
        });
        clue.sort((a, b) => {
            const curNumber = this.getCustomerOrderNumber('clue', a.customerRole);
            const preNumber = this.getCustomerOrderNumber('clue', b.customerRole);
            if (curNumber === preNumber) {
                return a.orgRank > b.orgRank ? -1 : 1;
            }
            return curNumber > preNumber ? -1 : 1;
        });
        this.logger('contact_edm_doSearchAll', this.useTime(start));
        return {
            contact,
            customer,
            clue,
        };
    }
    useTime(start) {
        return Date.now() - start + 'ms';
    }
    logger(key, data) {
        console.warn(key, data);
        this.loggerApi.track(key, {
            appendix: 'contact',
            data,
        });
    }
    async doSearchContact(params) {
        const { query, limit = this.contactUtil.searchTableLimit, lastId, count, dbName, tableName, filterName } = params;
        const _company = this.getCurrentDomain();
        const start = Date.now();
        const res = await this.dbApi.getByRangeCondition({
            dbName: dbName || this.contactUtil.contactCustomerGlobalDBName,
            tableName: tableName || this.tableNames.contact,
            adCondition: {
                type: 'above',
                args: [lastId || 0],
                field: 'id',
            },
            filter: filterName || customerFilterNames.searchContact,
            useDexieFilter: false,
            filterLimit: limit,
            query: {
                _company,
            },
            additionalData: {
                query,
                parentName: 'contact_edm_doSearchContact',
            },
            count,
        });
        this.logger('contact_edm_doSearchContact', this.useTime(start));
        return res;
    }
    async doSearchOrg(params) {
        const { query, limit = this.contactUtil.searchTableLimit, count, lastId, tableName, dbName } = params;
        const _company = this.getCurrentDomain();
        const start = Date.now();
        const res = await this.dbApi.getByRangeCondition({
            dbName: dbName || this.contactUtil.contactCustomerGlobalDBName,
            tableName: tableName || this.tableNames.org,
            filter: customerFilterNames.searchOrg,
            adCondition: {
                type: 'above',
                args: [lastId || 0],
                field: 'id',
            },
            filterLimit: limit,
            useDexieFilter: false,
            query: {
                _company,
            },
            count,
            additionalData: {
                query,
                parentName: 'contact_edm_doSearchOrg',
            },
        });
        this.logger('contact_edm_doSearchOrg', this.useTime(start));
        return res;
    }
    async doSearchMyCustomer(condition) {
        const viewRole = this.edmRoleApi.doGetContactViewPrivilege();
        if (!viewRole) {
            return [];
        }
        const { query, limit = 50, lastId, _account } = condition;
        const currentAccountId = await this.getCurrentContactId({ _account });
        const _company = this.getCurrentDomain();
        const searchOrgList = await this.dbApi.getByRangeCondition({
            dbName: this.contactUtil.edmcontactSearchDbName,
            tableName: this.tableNames.org,
            filter: customerFilterNames.searchMyCustomer,
            useDexieFilter: false,
            query: {
                _company,
            },
            additionalData: {
                searchParams: {
                    query,
                    type: 2002,
                    currentAccountId,
                },
                parentName: 'contact_edm_doSearchOrg',
            },
        });
        searchOrgList.sort((a, b) => (a.orgRank > b.orgRank ? -1 : 1));
        let index = searchOrgList.findIndex(item => item.id === lastId);
        index = index === -1 ? 0 : index;
        const res = searchOrgList.slice(index, index + limit);
        return res;
    }
    sendSelectNotifyByEmails(emails) {
        this.doGetContactByEmails({ emails: [...emails] });
    }
    async doGetCustomerContactByIds(params) {
        const { idList, contactList } = params;
        const orgContactList = await this.getOrgContactById({ idList, field: 'contactId' });
        const contactOrgMap = new Map();
        const orgIdSet = new Set();
        orgContactList.forEach(item => {
            contactOrgMap.set(item.contactId, item.orgId);
            orgIdSet.add(item.orgId);
        });
        const orgIdList = [...orgIdSet];
        const { orgMap, contactMap, orgIdRole } = await this.handleOrg({ orgIdList, contactIdList: idList, contactList });
        const res = [];
        idList.forEach(id => {
            const curOrgId = contactOrgMap.get(id);
            const { customerRole, hasRole } = this.getCustomerRole(orgIdRole, curOrgId);
            if (curOrgId && hasRole) {
                const mode = contactMap.get(id);
                if (mode) {
                    const curOrg = orgMap.get(curOrgId);
                    if (curOrg) {
                        mode.customerOrgModel = {
                            role: customerRole,
                            companyId: curOrgId,
                        };
                    }
                    res.push(mode);
                }
            }
        });
        this.contactSelectNotify.addRecentSelectContactMap([...contactMap.values()]);
        return res;
    }
    async doGetCustomerManagerByIds(params) {
        const { idList } = params;
        const orgManagerList = await this.getOrgManagerByOrgId({ idList });
        return this.transCustomerToSimpleContactModel(orgManagerList);
    }
    async transCustomerToSimpleContactModel(orgManagerList) {
        const contactIdSet = new Set();
        const res = {};
        const needSelectContactIdMap = {};
        orgManagerList.forEach(item => {
            if (item.managerAccount) {
                const list = res[item.orgId] || [];
                list.push({
                    account: item.managerAccount,
                    contactName: item.managerName,
                    contactId: item.managerId,
                });
                res[item.orgId] = list;
            }
            else {
                const list = needSelectContactIdMap[item.orgId] || [];
                list.push(item.managerId);
                contactIdSet.add(item.managerId);
                needSelectContactIdMap[item.orgId] = list;
            }
        });
        if (contactIdSet.size) {
            const contactList = await this.contactDB.getContactList({
                idList: [...contactIdSet],
            });
            const contactMap = util.listToMap(contactList, 'id');
            Object.keys(needSelectContactIdMap).forEach(orgId => {
                const list = res[orgId] || [];
                needSelectContactIdMap[orgId].forEach(contactId => {
                    const item = contactMap[contactId];
                    list.push({
                        account: item.accountName,
                        contactId: item.id,
                        contactName: item.contactName,
                    });
                });
                res[orgId] = list;
            });
        }
        return res;
    }
    async doGetContactByOrgIds(params) {
        try {
            const { idList } = params;
            const orgContactListOrigin = await this.getOrgContactById({ idList, field: 'orgId' });
            const orgContactList = await this.getOrgContactByEmails({
                emails: util.getKeyListByList(orgContactListOrigin, 'account', true),
            });
            const contactIdSet = new Set();
            const orgIdMap = new Map();
            orgContactList.forEach(item => {
                contactIdSet.add(item.contactId);
                const curIdSet = orgIdMap.get(item.orgId) || new Set();
                curIdSet.add(item.contactId);
                orgIdMap.set(item.orgId, curIdSet);
            });
            const { orgList, orgMap, contactMap, orgIdRole } = await this.handleOrg({ orgIdList: [...orgIdMap.keys()], contactIdList: [...contactIdSet] });
            const res = {};
            orgIdMap.forEach((curContactIdSet, orgId) => {
                const curOrg = orgMap.get(orgId);
                const modelList = [];
                let customerOrgModel;
                const { customerRole, hasRole } = this.getCustomerRole(orgIdRole, orgId);
                if (curOrg && hasRole) {
                    customerOrgModel = {
                        role: customerRole,
                        companyId: orgId,
                    };
                }
                if (hasRole) {
                    curContactIdSet.forEach(contactId => {
                        const curContact = contactMap.get(contactId);
                        if (curContact && curOrg) {
                            const newModel = Object.assign(Object.assign({}, curContact), { customerOrgModel });
                            modelList.push(newModel);
                            contactMap.set(contactId, newModel);
                        }
                    });
                }
                res[orgId] = modelList;
            });
            this.contactSelectNotify.addRecentSelectContactMap([...contactMap.values()]);
            this.contactSelectNotify.addRecentSelectOrgMap(orgList);
            return res;
        }
        catch (e) {
            console.error('[contact_edm] doGetContactByOrgIds error', e);
            return {};
        }
    }
    async doGetOrgList(params) {
        try {
            const viewRole = this.edmRoleApi.doGetContactViewPrivilege();
            if (!viewRole) {
                return [];
            }
            const { idList, type } = params || {};
            if (idList) {
                return this.getDataById({
                    tableName: this.tableNames.org,
                    idList,
                });
            }
            let currentContactId;
            try {
                currentContactId = await this.getCurrentContactId({
                    accountType: 'id',
                });
                console.warn('[contact_edm] doGetOrgList no curAccount');
            }
            catch (e) {
                console.error('[contact_edm] doGetOrgList no currentAccount error', e);
                return [];
            }
            const args = [this.getCurrentDomain(), currentContactId];
            const field = ['_company', 'managerId'];
            if (type) {
                args.push(type);
                field.push('customerType');
            }
            const managerList = await this.dbApi.getByRangeCondition({
                dbName: this.dbName,
                tableName: this.tableNames.orgManager,
                adCondition: {
                    field,
                    type: 'equals',
                    args: [args],
                },
            });
            const idSet = new Set();
            managerList.forEach(item => {
                idSet.add(item.orgId);
            });
            const orgList = await this.getDataById({
                tableName: 'org',
                idList: [...idSet],
            });
            const orderList = util.setDataOrder({
                data: orgList,
                orderBy: [['orgRank', false]],
            });
            this.contactSelectNotify.addRecentSelectOrgMap(orgList);
            return orderList;
        }
        catch (e) {
            console.error('[contact_edm] doGetOrgList error', e);
            return [];
        }
    }
    async doGetMyCustomerList(params) {
        try {
            const viewRole = this.edmRoleApi.doGetContactViewPrivilege();
            if (!viewRole) {
                return [];
            }
            const { lastId, limit } = params;
            let sortWeight = -Number.MAX_VALUE;
            if (lastId) {
                const startManager = await this.getOrgManagerByOrgId({ idList: [lastId] });
                if (!startManager || startManager.length === 0) {
                    return [];
                }
                sortWeight = startManager[0].sortWeight;
            }
            const field = ['_company', 'managerId', 'customerType', 'sortWeight'];
            const currentContactId = await this.getCurrentContactId({
                accountType: 'id',
            });
            const managerList = await this.dbApi.getByRangeCondition({
                dbName: this.dbName,
                tableName: this.tableNames.orgManager,
                count: limit + 1,
                adCondition: {
                    field,
                    type: 'between',
                    args: [
                        [this.getCurrentDomain(), currentContactId, 'customer', sortWeight],
                        [this.getCurrentDomain(), currentContactId, 'customer', 0],
                    ],
                },
            });
            if (managerList.length === limit + 1) {
                if (lastId) {
                    managerList.shift();
                }
                else {
                    managerList.pop();
                }
            }
            const orgIdList = [];
            managerList.forEach(item => {
                orgIdList.push(item.orgId);
            });
            const orgList = await this.getDataById({
                tableName: 'org',
                idList: orgIdList,
            });
            const orgMap = util.listToMap(orgList, 'id');
            const orderList = [];
            orgIdList.forEach(orgId => {
                orderList.push(orgMap[orgId]);
            });
            this.contactSelectNotify.addRecentSelectOrgMap(orderList);
            return orderList;
        }
        catch (e) {
            console.error('[contact_edm] doGetCustomerListFromDb error', e);
            return [];
        }
    }
    async doGetCustomerListFromDb(params) {
        try {
            const viewRole = this.edmRoleApi.doGetContactViewPrivilege();
            if (!viewRole) {
                return [];
            }
            const { lastId, limit } = params;
            let sortWeight = -Number.MAX_VALUE;
            if (lastId) {
                const startManager = await this.getOrgManagerByOrgId({ idList: ['customer_' + lastId] });
                if (!startManager || startManager.length === 0) {
                    return [];
                }
                sortWeight = startManager[0].sortWeight;
            }
            const field = ['_company', 'managerId', 'customerType', 'sortWeight'];
            const currentContactId = await this.getCurrentContactId({
                accountType: 'id',
            });
            const managerList = await this.dbApi.getByRangeCondition({
                dbName: this.dbName,
                tableName: this.tableNames.orgManager,
                count: limit + 1,
                adCondition: {
                    field,
                    type: 'between',
                    args: [[this.getCurrentDomain(), currentContactId, 'customer', sortWeight], [this.getCurrentDomain(), currentContactId, 'customer', 0], false, true],
                },
            });
            const orgIdList = [];
            managerList.forEach(item => {
                orgIdList.push(item.orgId);
            });
            const result = await this.doGetCustomerFromDbByIds({ idList: orgIdList });
            return result;
        }
        catch (e) {
            console.error('[contact_edm] doGetCustomerListFromDb error', e);
            return [];
        }
    }
    async doGetCustomerListFromServer(params) {
        const viewRole = this.edmRoleApi.doGetContactViewPrivilege();
        if (!viewRole) {
            return [];
        }
        const result = await this.contactServer.doGetCustomerListFromServer(params);
        if (Array.isArray(result) && result.length > 0) {
            const temp = this.handleCustomerListSeverRes(result);
            return temp;
        }
        return [];
    }
    async doGetCustomersFromServerBatch(params) {
        const result = await this.contactServer.doGetCustomersFromServerBatch(params);
        if (Array.isArray(result) && result.length > 0) {
            return this.handleCustomerListSeverRes(result);
        }
        return [];
    }
    async doDelCustomerManager(params) {
        const { idList: originId } = params;
        const idList = originId.map(this.contactTrans.createCustomerId);
        const _lastUpdateTime = Date.now();
        const currentContactId = await this.getCurrentContactId({
            accountType: 'id',
        });
        const orgManagerList = await this.getOrgManagerByOrgId({ idList });
        const orgManagerIdList = [];
        orgManagerList.forEach(item => {
            if (item._lastUpdateTime < _lastUpdateTime - 10 && item.managerId === currentContactId) {
                orgManagerIdList.push(item.id);
            }
        });
        await this.deleteData(this.tableNames.orgManager, orgManagerIdList);
    }
    async doSaveCustomerToDb(data) {
        const result = {
            orgList: [],
            contactList: [],
            orgContactList: [],
            managerList: [],
            idList: [],
        };
        data.forEach(item => {
            result.contactList = result.contactList.concat(item.contactList);
            result.orgContactList = result.orgContactList.concat(item.orgContactList);
            const managerList = item.managerList.map(manager => (Object.assign(Object.assign({}, manager), { sortWeight: -((manager.lastSetTopTime || 0) * 5 + (manager.lastMailTime || 0) * 2 + Number(item.originId || 0)) })));
            result.managerList = result.managerList.concat(managerList);
            result.idList.push(item.id);
            const _item = lodashOmit(item, ['contactList', 'orgContactList', 'managerList']);
            result.orgList.push(_item);
        });
        await this.doSaveCustomerListToDB(result);
    }
    async doGetCustomerFromDbByIds(params) {
        try {
            const result = [];
            const { idList } = params;
            const orgContactListOrigin = await this.getOrgContactById({ idList, field: 'orgId' });
            const contactIdSet = new Set();
            const orgIdOrgContactMap = new Map();
            const contactIdOrgIdMap = new Map();
            orgContactListOrigin.forEach(item => {
                contactIdSet.add(item.contactId);
                const curOrgContactSet = orgIdOrgContactMap.get(item.orgId) || new Set();
                curOrgContactSet.add(item);
                orgIdOrgContactMap.set(item.orgId, curOrgContactSet);
                contactIdOrgIdMap.set(item.contactId, item.orgId);
            });
            const [orgList, contactList, managerList] = await Promise.all([
                this.getDataById({
                    idList,
                    tableName: this.tableNames.org,
                }),
                this.getDataById({
                    idList: [...contactIdSet],
                    tableName: this.tableNames.contact,
                }),
                this.getOrgManagerByOrgId({ idList }),
            ]);
            const orgIdOrgMap = new Map();
            orgList.forEach(item => {
                orgIdOrgMap.set(item.id, item);
            });
            const orgIdmanagerListMap = new Map();
            managerList.forEach(item => {
                const curOrgIdManagerSet = orgIdmanagerListMap.get(item.orgId) || new Set();
                curOrgIdManagerSet.add(item);
                orgIdmanagerListMap.set(item.orgId, curOrgIdManagerSet);
            });
            const orgIdcontactListMap = new Map();
            contactList.forEach(item => {
                const orgId = contactIdOrgIdMap.get(item.id);
                if (orgId) {
                    const curOrgIdContactSet = orgIdcontactListMap.get(orgId) || new Set();
                    curOrgIdContactSet.add(item);
                    orgIdcontactListMap.set(orgId, curOrgIdContactSet);
                }
            });
            idList.forEach(orgId => {
                const _contactList = [...(orgIdcontactListMap.get(orgId) || [])];
                const _managerList = [...(orgIdmanagerListMap.get(orgId) || [])];
                const _orgContactList = [...(orgIdOrgContactMap.get(orgId) || [])];
                const org = orgIdOrgMap.get(orgId);
                if (org) {
                    result.push(Object.assign(Object.assign({}, org), { contactList: _contactList, managerList: _managerList, orgContactList: _orgContactList }));
                }
            });
            return result;
        }
        catch (e) {
            console.error('[contact_edm] doGetCustomerFromDbByIds error', e);
            return [];
        }
    }
    async getOrgAllRole(orgManagerList) {
        const currentContactId = await this.getCurrentContactId({
            accountType: 'id',
        });
        const viewRole = this.edmRoleApi.doGetContactViewPrivilege();
        const roleAccountIds = this.edmRoleApi.doGetContactPrivilegeRangeData() || [];
        const orgIdRole = new Map();
        orgManagerList.forEach(item => {
            if (!viewRole) {
                orgIdRole.set(item.orgId, 'noRoleColleague');
            }
            else {
                const preRole = orgIdRole.get(item.orgId);
                let curRole = 'noRoleColleague';
                if (currentContactId === item.managerId) {
                    curRole = roleAccountIds.includes(item.managerId) ? 'manager' : 'noRoleManager';
                }
                else {
                    curRole = roleAccountIds.includes(item.managerId) ? 'colleague' : 'noRoleColleague';
                }
                orgIdRole.set(item.orgId, this.compareRole(curRole, preRole));
            }
        });
        return orgIdRole;
    }
    async handleOrg(params) {
        const { orgIdList, contactIdList, contactList: defaultList } = params;
        const [orgManagerList, orgList, contactMap] = await Promise.all([
            this.getOrgManagerByOrgId({
                idList: orgIdList,
            }),
            this.getDataById({
                idList: orgIdList,
                tableName: this.tableNames.org,
            }),
            defaultList
                ? Promise.resolve((() => {
                    const _contactMap = new Map();
                    defaultList.forEach(item => {
                        _contactMap.set(item.contact.id, item);
                    });
                    return _contactMap;
                })())
                : this.getDataById({
                    tableName: this.tableNames.contact,
                    idList: contactIdList,
                }).then(res => {
                    const _contactMap = new Map();
                    res.forEach(item => {
                        _contactMap.set(item.id, this.contactTrans.transCustomerToContactModel(item));
                    });
                    return _contactMap;
                }),
        ]);
        const orgIdRole = await this.getOrgAllRole(orgManagerList);
        const orgMap = new Map();
        orgList.forEach(item => {
            orgMap.set(item.id, item);
        });
        return {
            orgMap,
            contactMap,
            orgIdRole,
            orgList,
        };
    }
    compareRole(curRole, preRole) {
        if (!preRole) {
            return curRole;
        }
        const roleList = ['noRoleManager', 'manager', 'colleague', 'noRoleColleague'];
        const res = roleList.find(item => curRole === item || preRole === item);
        return res || curRole;
    }
    getCustomerRole(orgIdRoleMap, orgId) {
        if (!orgId) {
            return {
                customerRole: 'external',
                hasRole: false,
            };
        }
        const role = orgIdRoleMap.get(orgId);
        if (!role) {
            return {
                hasRole: true,
                customerRole: 'openSeaCustomer',
            };
        }
        const customerRole = this.contactTrans.transCustomerRole2EmailRole('customer', role);
        return {
            hasRole: !role.endsWith('NoAuth'),
            customerRole,
        };
    }
    async doGetContactByEmails(params) {
        var _a;
        try {
            const viewRole = this.edmRoleApi.doGetContactViewPrivilege();
            if (!viewRole) {
                return {
                    modelRes: {},
                    modelListRes: {},
                };
            }
            const orgContactList = await this.getOrgContactByEmails(params);
            const orgIdSet = new Set();
            const contactIdSet = new Set();
            const orgiginEmailMap = (_a = params.emails) === null || _a === void 0 ? void 0 : _a.reduce((res, email) => {
                if (email) {
                    const lowEmail = email.toLocaleLowerCase();
                    res.set(lowEmail, email);
                }
                return res;
            }, new Map());
            const emailContactMap = new Map();
            const contactOrgMap = new Map();
            orgContactList.forEach(item => {
                const contactSet = emailContactMap.get(item.account) || new Set();
                contactSet.add(item.contactId);
                emailContactMap.set(item.account, contactSet);
                contactOrgMap.set(item.contactId, item.orgId);
                orgIdSet.add(item.orgId);
                contactIdSet.add(item.contactId);
            });
            const { orgList, orgMap, contactMap, orgIdRole } = await this.handleOrg({ orgIdList: [...orgIdSet], contactIdList: [...contactIdSet] });
            const res = {};
            const modelListRes = {};
            emailContactMap.forEach((item, _email) => {
                let emailContactModel;
                const emailContactModelList = [];
                const email = orgiginEmailMap.get(_email);
                if (email) {
                    item.forEach(contactId => {
                        const model = contactMap.get(contactId);
                        const currentOrgId = contactOrgMap.get(contactId);
                        const { customerRole, hasRole } = this.getCustomerRole(orgIdRole, currentOrgId);
                        if (model && currentOrgId && hasRole) {
                            const currentOrg = orgMap.get(currentOrgId);
                            if (currentOrg) {
                                const relModel = Object.assign(Object.assign({}, model), { customerOrgModel: {
                                        role: customerRole,
                                        companyId: currentOrgId,
                                    } });
                                emailContactModelList.push(relModel);
                                emailContactModel = this.validCustomer(relModel, emailContactModel);
                                contactMap.set(contactId, relModel);
                            }
                            else {
                                emailContactModel = this.validCustomer(model, emailContactModel);
                            }
                        }
                    });
                    if (emailContactModel) {
                        res[email] = emailContactModel;
                    }
                    modelListRes[email] = emailContactModelList;
                }
            });
            this.contactSelectNotify.addRecentSelectContactMap([...contactMap.values()]);
            this.contactSelectNotify.addRecentSelectOrgMap(orgList);
            return {
                modelRes: res,
                modelListRes,
            };
        }
        catch (e) {
            console.error('[contact_edm_help] doGetContactByEmails', e);
            return {
                modelRes: {},
                modelListRes: {},
            };
        }
    }
    async doUpdateClueToCustomer(params) {
        const { clueId, email, customerData } = params;
        const curClue = await this.getDataById({
            tableName: this.tableNames.org,
            idList: [clueId],
        });
        const res = await this.handleCustomerList({
            data: [customerData],
            sendEvent: true,
        });
        if (curClue.length) {
            this.putAll(this.tableNames.org, [Object.assign(Object.assign({}, curClue[0]), { status: '4' })]);
        }
        const curContact = res.contactList.find(item => item.account === (email === null || email === void 0 ? void 0 : email.toLocaleLowerCase()));
        if (curContact && res.orgList.length) {
            const curContactModel = Object.assign(Object.assign({}, this.contactTrans.transCustomerToContactModel(curContact)), { customerOrgModel: {
                    role: 'myCustomer',
                    companyId: res.orgList[0].id,
                } });
            this.contactSelectNotify.addRecentSelectContactMap([curContactModel]);
            this.contactSelectNotify.addRecentSelectOrgMap(res.orgList);
            return curContactModel;
        }
        return undefined;
    }
    async doInsertCustomer(params) {
        const { customerData, customerType = 'customer' } = params;
        const res = customerType === 'clue'
            ? await this.handleClueList({ data: [customerData] })
            : await this.handleCustomerList({
                data: [customerData],
                sendEvent: true,
            });
        if (res.orgList.length && res.contactList.length) {
            const contactModelList = res.contactList.map(item => (Object.assign(Object.assign({}, this.contactTrans.transCustomerToContactModel(item)), { customerOrgModel: {
                    role: 'myCustomer',
                    companyId: customerData.id,
                } })));
            this.contactSelectNotify.addRecentSelectContactMap(contactModelList);
            this.contactSelectNotify.addRecentSelectOrgMap(res.orgList);
            return contactModelList;
        }
        return undefined;
    }
    getCustomerOrderNumber(customerType, emailRole, status) {
        const customerRole = this.contactTrans.transEmailRole2CustomerRole(emailRole);
        const roleNumber = {
            manager: 4,
            colleague: 3,
            openSea: 2,
            other: 1,
        };
        const typeNumber = {
            customer: 10,
            clue: 0,
            openSea: -10,
        };
        const statusNumber = customerType === 'clue' && status === '4' ? -0.5 : 0;
        const roleValue = customerRole ? roleNumber[customerRole] : 1;
        return typeNumber[customerType] + roleValue + statusNumber;
    }
    validCustomer(cur, pre) {
        if (!pre) {
            return cur;
        }
        const curData = cur.customerOrgModel;
        const preData = pre.customerOrgModel;
        if (!preData) {
            return cur;
        }
        if (!curData) {
            return pre;
        }
        const curRole = this.parseRole(curData.role);
        const preRole = this.parseRole(preData.role);
        const curNumber = this.getCustomerOrderNumber(curRole.customerType, curData.role);
        const preNumber = this.getCustomerOrderNumber(preRole.customerType, preData.role);
        if (curNumber === preNumber) {
            const curCreateTime = curData.createTime || 0;
            const preCreateTime = preData.createTime || 0;
            return curCreateTime > preCreateTime ? cur : pre;
        }
        return curNumber > preNumber ? cur : pre;
    }
    async putAll(tableName, data) {
        if (!data.length) {
            return [];
        }
        return this.dbApi.putAll({ tableName, dbName: this.dbName }, data);
    }
    deleteData(tableName, idList) {
        if (!idList.length) {
            return Promise.resolve();
        }
        return this.dbApi.deleteById({ tableName, dbName: this.dbName }, idList);
    }
    async getDataById(params) {
        const { tableName, idList, needLog } = params;
        const start = Date.now();
        const res = await this.dbApi.getByRangeCondition({
            tableName,
            dbName: this.dbName,
            adCondition: {
                args: [idList],
                type: 'anyOf',
                field: 'id',
            },
            additionalData: needLog
                ? {
                    parentName: 'contact_edm_getDataById',
                }
                : undefined,
        });
        if (needLog) {
            this.logger('contact_edm_getDataById', this.useTime(start));
        }
        return res;
    }
    async getOrgContactById(params) {
        const { idList, field, needLog } = params;
        const start = Date.now();
        const res = await this.dbApi.getByRangeCondition({
            dbName: this.dbName,
            tableName: this.tableNames.orgContact,
            adCondition: {
                field,
                args: [idList],
                type: 'anyOf',
            },
            additionalData: needLog
                ? {
                    parentName: 'contact_edm_getOrgContactById',
                }
                : undefined,
        });
        if (needLog) {
            this.logger('contact_edm_getOrgContactById', this.useTime(start));
        }
        return res;
    }
    getOrgContactByEmails(params) {
        const { emails } = params;
        const _company = this.getCurrentDomain();
        const _emails = emails.map(email => email === null || email === void 0 ? void 0 : email.toLocaleLowerCase());
        const args = util.cartesian([[_company], _emails]);
        return this.dbApi.getByRangeCondition({
            tableName: this.tableNames.orgContact,
            dbName: this.dbName,
            adCondition: {
                args,
                field: ['_company', 'account'],
                type: 'anyOf',
            },
        });
    }
    async getOrgManagerByOrgId(params) {
        const { idList, needLog } = params;
        const start = Date.now();
        const res = await this.dbApi.getByRangeCondition({
            dbName: this.dbName,
            tableName: this.tableNames.orgManager,
            adCondition: {
                field: 'orgId',
                args: [idList],
                type: 'anyOf',
            },
            additionalData: needLog
                ? {
                    parentName: 'contact_edm_getOrgManagerByOrgId',
                }
                : undefined,
        });
        if (needLog) {
            this.logger('contact_edm_getOrgManagerByOrgId', this.useTime(start));
        }
        return res;
    }
    getLabelByOrgId(params) {
        const { idList } = params;
        return this.dbApi.getByRangeCondition({
            dbName: this.dbName,
            tableName: this.tableNames.label,
            adCondition: {
                field: 'orgId',
                args: [idList],
                type: 'anyOf',
            },
        });
    }
    async deleteDataByOrgId(idList, _lastUpdateTime) {
        const [orgList, orgManagerList, orgContactList] = await Promise.all([
            this.getDataById({ tableName: this.tableNames.org, idList }),
            this.getOrgManagerByOrgId({ idList }),
            this.getOrgContactById({
                idList,
                field: 'orgId',
            }),
        ]);
        const orgManagerIdList = [];
        const orgContactIdList = [];
        const contactIdList = [];
        const orgIdList = [];
        orgList.forEach(item => {
            if (item._lastUpdateTime < _lastUpdateTime - 10) {
                orgIdList.push(item.id);
            }
        });
        orgManagerList.forEach(item => {
            if (item._lastUpdateTime < _lastUpdateTime - 10) {
                orgManagerIdList.push(item.id);
            }
        });
        orgContactList.forEach(item => {
            if (item._lastUpdateTime < _lastUpdateTime - 10) {
                orgContactIdList.push(item.id);
                contactIdList.push(item.contactId);
            }
        });
        await Promise.all([
            this.deleteData(this.tableNames.orgContact, orgContactIdList),
            this.deleteData(this.tableNames.orgManager, orgManagerIdList),
            this.deleteData(this.tableNames.contact, contactIdList),
            this.deleteData(this.tableNames.org, orgIdList),
        ]);
        return {
            orgIdList,
            contactIdList,
            orgManagerIdList,
            orgContactIdList,
        };
    }
    deleteDataByLastUpdateTime(params) {
        const { type, tableName, _lastUpdateTime, dbName = this.dbName } = params;
        const _company = this.getCurrentDomain();
        return this.dbApi.deleteByByRangeCondition({
            dbName,
            tableName,
            adCondition: {
                field: ['_company', 'customerType', '_lastUpdateTime'],
                args: [[_company, type, 0], [_company, type, _lastUpdateTime - 10], true, true],
                type: 'between',
            },
        });
    }
    initDB() {
        this.dbApi.initDb(this.dbName);
    }
}
export const ContactEdmHelperInstance = new ContactEdmHelper();
